import store from "@/store";
import { mappers } from "@/mappers";

export const productMixin = {
  methods: {
    getProductUnitPossibilities(product) {
      if (product && product.data) {
        if (product.data.use_conversion_formula) {
          if (product.data.use_alternative_unit === true) {
            const possibilities = [];
            if (!mappers.isCustomUnit(product.data.unite_mesure)) {
              this.$units()
                .from(product.data.unite_mesure)
                .possibilities()
                .filter(x => store.getters.getAllowedUnits.includes(x))
                .forEach(x => possibilities.push(x));
            } else if (mappers.isCustomUnit(product.data.unite_mesure)) {
              store.getters.getCustomUnitsValues.forEach(x =>
                possibilities.push(x)
              );
            }
            if (
              !mappers.isCustomUnit(
                product.data.alternative_unite_mesure_production
              )
            ) {
              this.$units()
                .from(product.data.alternative_unite_mesure_production)
                .possibilities()
                .filter(x => store.getters.getAllowedUnits.includes(x))
                .forEach(x => possibilities.push(x));
            } else if (
              mappers.isCustomUnit(
                product.data.alternative_unite_mesure_production
              )
            ) {
              store.getters.getCustomUnitsValues.forEach(x =>
                possibilities.push(x)
              );
            }
            return possibilities;
          } else {
            if (!mappers.isCustomUnit(product.data.unite_mesure)) {
              return this.$units()
                .from(product.data.unite_mesure)
                .possibilities()
                .filter(x => store.getters.getAllowedUnits.includes(x));
            } else if (mappers.isCustomUnit(product.data.unite_mesure)) {
              return [product.data.unite_mesure];
            } else {
              return [];
            }
          }
        } else {
          if (!mappers.isCustomUnit(product.data.unite_mesure_inventory)) {
            return this.$units()
              .from(product.data.unite_mesure_inventory)
              .possibilities()
              .filter(x => store.getters.getAllowedUnits.includes(x));
          } else if (
            mappers.isCustomUnit(product.data.unite_mesure_inventory)
          ) {
            return [product.data.unite_mesure_inventory];
          } else {
            return [];
          }
        }
      } else {
        return [];
      }
    }
  }
};
